var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty, Complex, Browser } from '@syncfusion/ej2-base';
import { Rect, TextBasic, RectOption, TextOption, CurrentRect, DrawSvgCanvas } from '../utils/helper';
import { convertHexToColor, colorNameToHex } from '../utils/helper';
import { CellColor } from '../utils/colorMapping';
import { Border, Font } from '../model/base';
import { Theme } from '../model/theme';
/**
 * Configures the CellSettings property in the Heatmap.
 */
var CellSettings = /** @class */ (function (_super) {
    __extends(CellSettings, _super);
    function CellSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(true)
    ], CellSettings.prototype, "showLabel", void 0);
    __decorate([
        Property('')
    ], CellSettings.prototype, "format", void 0);
    __decorate([
        Property(true)
    ], CellSettings.prototype, "enableCellHighlighting", void 0);
    __decorate([
        Complex({}, Border)
    ], CellSettings.prototype, "border", void 0);
    __decorate([
        Complex(Theme.rectLabelFont, Font)
    ], CellSettings.prototype, "textStyle", void 0);
    return CellSettings;
}(ChildProperty));
export { CellSettings };
var Series = /** @class */ (function () {
    function Series(heatMap) {
        this.heatMap = heatMap;
        this.drawSvgCanvas = new DrawSvgCanvas(this.heatMap);
        this.cellColor = new CellColor(this.heatMap);
    }
    /**
     * To render rect series.
     * @return {void}
     * @private
     */
    Series.prototype.renderRectSeries = function () {
        if (!this.heatMap.enableCanvasRendering) {
            this.containerRectObject = this.heatMap.renderer.createGroup({
                id: this.heatMap.element.id + '_Container_RectGroup',
                x: this.heatMap.initialClipRect.x, y: this.heatMap.initialClipRect.y, transform: 'translate( 0, 0)'
            });
            if (this.heatMap.cellSettings.showLabel) {
                this.containerTextObject = this.heatMap.renderer.createGroup({ id: this.heatMap.element.id + '_Container_TextGroup', transform: 'translate( 0, 0)' });
            }
        }
        this.heatMap.xLength = this.heatMap.axisCollections[0].axisLabelSize;
        this.heatMap.yLength = this.heatMap.axisCollections[1].axisLabelSize;
        // Rectangle Part
        var tempX = Math.round(this.heatMap.initialClipRect.x);
        var tempY = Math.round(this.heatMap.initialClipRect.y);
        var dataXIndex = 0;
        var dataYIndex = 0;
        var tempWidth = Math.round(((this.heatMap.initialClipRect.width -
            (this.heatMap.cellSettings.border.width / 2)) / this.heatMap.xLength) * 100) / 100;
        var tempHeight = Math.round(((this.heatMap.initialClipRect.height -
            (this.heatMap.cellSettings.border.width / 2)) / this.heatMap.yLength) * 100) / 100;
        var tempVal = 0;
        var themeStyle = this.heatMap.themeStyle;
        var color = '';
        var tempBorder;
        var tempRectPosition = [];
        tempBorder = this.heatMap.cellSettings.border;
        this.rectPositionCollection = [];
        this.checkLabelYDisplay = tempHeight > parseInt(this.heatMap.cellSettings.textStyle.size, 10) ? true : false;
        var tempMaxString = this.getFormatedText(this.heatMap.dataSourceMaxValue, this.heatMap.cellSettings.format);
        this.checkLabelXDisplay = tempWidth > (tempMaxString.length *
            (parseInt(this.heatMap.cellSettings.textStyle.size, 10) / 2)) ? true : false;
        if (this.heatMap.yAxis.opposedPosition) {
            tempX = Math.round((this.heatMap.initialClipRect.x + (tempBorder.width / 2)) * 100) / 100;
        }
        for (var x = 0; x < (this.heatMap.xLength * this.heatMap.yLength); x++) {
            var text = this.heatMap.clonedDataSource[dataXIndex][dataYIndex];
            var rectPosition = new CurrentRect(0, 0, 0, 0, 0, '');
            color = this.cellColor.getColorByValue(text);
            var rect = new RectOption(this.heatMap.element.id + '_HeatMapRect_' + x, color, tempBorder, 1, new Rect(tempX, tempY, tempWidth, tempHeight), tempBorder.color || this.heatMap.themeStyle.cellBorder, tempBorder.radius, tempBorder.radius);
            this.drawSvgCanvas.drawRectangle(rect, this.containerRectObject);
            rectPosition.x = tempX;
            rectPosition.y = tempY;
            rectPosition.width = tempWidth;
            rectPosition.height = tempHeight;
            rectPosition.value = text;
            rectPosition.id = this.heatMap.element.id + '_HeatMapRect_' + x;
            tempRectPosition.push(rectPosition);
            if (this.heatMap.cellSettings.showLabel && this.checkLabelYDisplay && this.checkLabelXDisplay) {
                var displayText = this.getFormatedText(text, this.heatMap.cellSettings.format);
                var themeCellTextStyle = this.heatMap.cellSettings.textStyle;
                var options = new TextOption(this.heatMap.element.id + '_HeatMapRectLabels_' + x, new TextBasic(Math.round((tempX + tempWidth / 2) * 100) / 100, Math.round((tempY + tempHeight / 2) * 100) / 100, 'middle', displayText, null, null, 'middle'), themeCellTextStyle, themeCellTextStyle.color || this.getSaturatedColor(color));
                this.drawSvgCanvas.createText(options, this.containerTextObject, displayText);
                if (Browser.isIE && !this.heatMap.enableCanvasRendering) {
                    this.containerTextObject.childNodes[x].setAttribute('dy', '1ex');
                }
            }
            if (tempVal === this.heatMap.xLength - 1) {
                tempY = Math.round((tempY + tempHeight) * 100) / 100;
                tempVal = 0;
                dataYIndex = 0;
                if (this.heatMap.yAxis.opposedPosition) {
                    tempX = Math.round((this.heatMap.initialClipRect.x + (tempBorder.width / 2)) * 100) / 100;
                }
                else {
                    tempX = Math.round(this.heatMap.initialClipRect.x);
                }
                this.rectPositionCollection.push(tempRectPosition);
                tempRectPosition = [];
                dataXIndex++;
            }
            else {
                tempX = Math.round((tempX + tempWidth) * 100) / 100;
                tempVal++;
                dataYIndex++;
            }
        }
        if (!this.heatMap.enableCanvasRendering) {
            this.heatMap.svgObject.appendChild(this.containerRectObject);
            if (this.heatMap.cellSettings.showLabel) {
                this.heatMap.svgObject.appendChild(this.containerTextObject);
            }
        }
    };
    /**
     * To find saturated color for datalabel.
     * @return {string}
     * @private
     */
    Series.prototype.getSaturatedColor = function (color) {
        var saturatedColor = color;
        saturatedColor = (saturatedColor === 'transparent') ? window.getComputedStyle(document.body, null).backgroundColor : saturatedColor;
        var rgbValue = convertHexToColor(colorNameToHex(saturatedColor));
        var contrast = Math.round((rgbValue.R * 299 + rgbValue.G * 587 + rgbValue.B * 114) / 1000);
        return contrast >= 128 ? 'black' : 'white';
    };
    /**
     * To highlight the mouse hovered rect cell.
     * @return {void}
     * @private
     */
    Series.prototype.highlightSvgRect = function (tempID) {
        if (tempID.indexOf('Celltooltip') === -1) {
            if (tempID.indexOf('_HeatMapRect') !== -1) {
                if (tempID.indexOf('_HeatMapRectLabels_') !== -1) {
                    var tempIndex = tempID.indexOf('_HeatMapRectLabels_') + 19;
                    tempID = this.heatMap.element.id + '_HeatMapRect_' + tempID.slice(tempIndex);
                }
                var element = document.getElementById(tempID);
                if (this.heatMap.tempRectHoverClass !== tempID) {
                    if (this.heatMap.cellSettings.enableCellHighlighting) {
                        var oldElement = document.getElementById(this.heatMap.tempRectHoverClass);
                        if (oldElement) {
                            oldElement.style.opacity = '1';
                        }
                        element.style.opacity = '0.65';
                    }
                    this.heatMap.tempRectHoverClass = tempID;
                }
            }
            else {
                if (this.heatMap.cellSettings.enableCellHighlighting) {
                    var oldElement = document.getElementById(this.heatMap.tempRectHoverClass);
                    if (oldElement) {
                        oldElement.style.opacity = '1';
                        this.heatMap.tempRectHoverClass = '';
                    }
                }
            }
        }
    };
    /**
     * To get the value depends to format.
     * @return {string}
     * @private
     */
    Series.prototype.getFormatedText = function (val, getFormat) {
        var format = getFormat;
        var isCustom = format.match('{value}') !== null;
        this.format = this.heatMap.intl.getNumberFormat({
            format: isCustom ? '' : format
        });
        var value = '';
        if (val.toString() !== '') {
            value = this.formatValue(isCustom, format, val);
        }
        return value;
    };
    /**
     * To get mouse hovered cell details.
     * @return {CurrentRect}
     * @private
     */
    Series.prototype.getCurrentRect = function (x, y) {
        var currentRect;
        var firstRectDetails = [];
        firstRectDetails.push(this.heatMap.heatMapSeries.rectPositionCollection[0][0]);
        var rectX = Math.ceil((x - firstRectDetails[0].x) / firstRectDetails[0].width) <
            this.heatMap.axisCollections[0].axisLabelSize ?
            Math.ceil((x - firstRectDetails[0].x) / firstRectDetails[0].width) :
            this.heatMap.axisCollections[0].axisLabelSize;
        var rectY = Math.floor(((y - firstRectDetails[0].y) / firstRectDetails[0].height)) <
            this.heatMap.axisCollections[1].axisLabelSize ?
            Math.floor(((y - firstRectDetails[0].y) / firstRectDetails[0].height)) :
            this.heatMap.axisCollections[1].axisLabelSize - 1;
        rectX = rectX === 0 ? 1 : rectX;
        currentRect = this.heatMap.heatMapSeries.rectPositionCollection[rectY][rectX - 1];
        this.hoverXAxisLabel = this.heatMap.axisCollections[0].tooltipLabels[rectX - 1];
        this.hoverXAxisValue = this.heatMap.axisCollections[0].labelValue[rectX - 1];
        this.hoverYAxisLabel = this.heatMap.axisCollections[1].tooltipLabels[(this.heatMap.axisCollections[1].tooltipLabels.length - 1) - rectY];
        this.hoverYAxisValue = this.heatMap.axisCollections[1].labelValue[(this.heatMap.axisCollections[1].labelValue.length - 1) - rectY];
        return currentRect;
    };
    /**
     * Format the cell label.
     * @private
     */
    Series.prototype.formatValue = function (isCustom, format, tempInterval) {
        return isCustom ? format.replace('{value}', this.format(tempInterval))
            : this.format(tempInterval);
    };
    return Series;
}());
export { Series };
